import { Skeleton, Stack, StackProps, Tooltip, Typography } from '@mui/material';
import { COLOR_BLACK, COLOR_STROKE, Icons } from 'shared';

interface BonusTipProps {
  currentBonus: string | undefined;
  loading?: boolean;
}

const TipContent = () => {
  return (
    <Stack rowGap={1} justifyContent="center" sx={{ color: COLOR_BLACK, '& strong': { fontWeight: 600 } }}>
      <Typography variant="body2" color="inherit">
        Bonus: <strong>5%</strong> from $10 to $500
      </Typography>
      <Typography variant="body2" color="inherit">
        Bonus: <strong>10%</strong> from $501 to $1000
      </Typography>
      <Typography variant="body2" color="inherit">
        Bonus: <strong>20%</strong> from $1001 to Up
      </Typography>
    </Stack>
  );
};

export const BonusTip = ({ currentBonus, loading, ...props }: BonusTipProps & StackProps) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} {...props}>
      <Typography variant="body1" className="primary" noWrap>
        Bonus:{' '}
        <Typography variant="inherit" component="span" className="accent" noWrap>
          {loading ? (
            <Skeleton variant="rounded" sx={{ display: 'inline-block', width: 24, verticalAlign: 'middle' }} />
          ) : (
            `${currentBonus ?? 0}%`
          )}
        </Typography>
      </Typography>
      <Tooltip
        title={<TipContent />}
        arrow={false}
        enterTouchDelay={0}
        placement="bottom"
        classes={{
          tooltip: 'tertinary',
        }}
        slotProps={{
          tooltip: {
            sx: {
              width: '100%',
            },
          },
        }}
      >
        <Stack display="inline-flex">
          <Icons.InfoCircle
            sx={{
              color: COLOR_STROKE,
            }}
          />
        </Stack>
      </Tooltip>
    </Stack>
  );
};
